// Dubai - personal trainer price.
const content = {
    slug: 'personal-trainer-price',
    title: (c) => `Personal Trainer Price in Dubai | ${c.money(c.lowest, 0)}-${c.money(c.pt('Elite', 14), 0)} per Session`,
    description: (c) =>
        `What a personal trainer costs in Dubai: ${c.money(c.lowest, 0)} to ${c.money(c.pt('Elite', 14), 0)} a session with StringsSG, vs typical market rates. Packages, partner training and what changes the price.`,
    eyebrow: 'Dubai · Prices',
    h1: 'Personal Trainer Prices in Dubai',
    lead: (c) =>
        `Home and building-gym personal training in Dubai, priced per session and sold in packages. Signature trainers start at ${c.money(c.pt('Signature', 14), 0)} and drop to ${c.money(c.pt('Signature', 50), 0)} a session on our longest package.`,
    image: 'fitness-package6.jpg',
    imageAlt: 'Personal training package session in progress',
    facts: ['Per-session pricing', 'Packages of 14 to 50', 'No joining fee'],
    packagesTitle: 'Package prices',
    sections: [
        {
            title: 'What personal training usually costs in Dubai',
            paragraphs: [
                'Home personal training in Dubai is commonly advertised at around AED 250 to AED 300 a session, with specialist and premium trainers charging more, and trainers at big-brand gyms often charging gym-floor rates on top of a membership. Prices vary with the trainer\'s experience, where the session happens, and how many sessions you commit to.',
                'We price below that range to build our client base in Dubai, and we keep it simple: one price per session for each package length and trainer level, with three clear modifiers.',
            ],
        },
        {
            title: 'What changes the price',
            tone: 'muted',
            cards: [
                { title: 'Trainer level', body: (c) => `Signature trainers (2+ years) from ${c.money(c.pt('Signature', 50), 0)}; Elite trainers (5+ years) from ${c.money(c.pt('Elite', 50), 0)} a session.` },
                { title: 'Package length', body: (c) => `14 sessions at ${c.money(c.pt('Signature', 14), 0)}; 50 sessions at ${c.money(c.pt('Signature', 50), 0)} a session.` },
                { title: 'Time of day', body: (c) => `Weekday 9am-4pm is the listed price; evenings, early mornings and weekends add ${c.money(c.mods.peak, 0)} a session.` },
                { title: 'Trainer preference', body: (c) => `Asking specifically for a female trainer adds ${c.money(c.mods.female, 0)} a session.` },
                { title: 'Partner training', body: 'Two people sharing a session pay about 70% of the solo price each.' },
                { title: 'Booking online', body: (c) => `Booking through the website saves ${c.money(c.mods.online, 0)} on every session.` },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is a personal trainer per session in Dubai?',
            answer: (c) => `From ${c.money(c.lowest, 0)} to ${c.money(c.pt('Elite', 14), 0)} a session with StringsSG, depending on package length and trainer level.`,
        },
        {
            question: 'Is there a joining or registration fee?',
            answer: 'No. You pay for the package only.',
        },
        {
            question: 'Can I pay in instalments?',
            answer: 'Packages of 30 sessions or more can be split into instalments - ask our team when you book.',
        },
        {
            question: 'Is a personal trainer cheaper than a gym membership?',
            answer: 'Not per month, but a trainer replaces guesswork with a plan and accountability. Many clients train at their building gym, so they pay for the trainer but not a membership.',
        },
    ],
    schema: { name: 'Personal Trainer Prices in Dubai' },
}

export default content
